/* global process */
import React from 'react';
import { createRoot } from 'react-dom/client';
import { createStore, applyMiddleware } from 'redux';
import 'regenerator-runtime/runtime';
import { Provider } from 'react-redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { thunk } from 'redux-thunk';

import requestManager from './requestManager';
import { setData } from 'actions/actions.js';
import reducer from 'reducers/rootReducer.js';

import App from './app';
import './index.scss';

if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log('Looks like we are in development mode!');
}

const middlewares = [thunk];

let el = document.querySelector('app-Portfolio');

const store = createStore(
    reducer,
    composeWithDevTools(applyMiddleware(...middlewares))
);

requestManager.getData().then(resp => {
    store.dispatch(setData(resp));
});

const root = createRoot(el);

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);
